import { createFileRoute } from "@tanstack/react-router";
import type * as React from "react";

import { ConsoleSchemaPage, consoleSourcesQueryOptions } from "@/features/console";

export interface ConsoleSchemaSearch {
  /** The selected node id (``conn_<uuid>`` or ``facet:…``) — deep-linkable. */
  sel?: string;
  /** State filter; absent = "all". */
  f?: "ready" | "pending";
}

export const Route = createFileRoute("/_authed/_modal/console/schema")({
  // Selection + filter live in the URL so a teammate can be linked straight to
  // "curate this source", and reload / browser-back keep their place.
  validateSearch: (search: Record<string, unknown>): ConsoleSchemaSearch => ({
    sel: typeof search.sel === "string" ? search.sel : undefined,
    f: search.f === "ready" || search.f === "pending" ? search.f : undefined,
  }),
  // Intent preload — warm the structured-source list; the per-source schema is
  // fetched on selection inside the page.
  loader: ({ context: { queryClient } }) => {
    void queryClient.ensureQueryData(consoleSourcesQueryOptions());
  },
  component: ConsoleSchemaRoute,
});

function ConsoleSchemaRoute(): React.ReactElement {
  const { sel, f } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ConsoleSchemaPage
      selectedId={sel ?? null}
      filter={f ?? "all"}
      onSelect={(id) => {
        void navigate({ search: (p) => ({ ...p, sel: id }), replace: true });
      }}
      onFilter={(next) => {
        void navigate({
          search: (p) => ({ ...p, f: next === "all" ? undefined : next }),
          replace: true,
        });
      }}
    />
  );
}
